import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Note } from 'src/app/service/common/interface';
import { MessageService } from 'src/app/service/common/message.service';
import { NotesService } from 'src/app/service/common/notes.service';

@Component({
  selector: 'app-note-modal',
  templateUrl: './note-modal.component.html',
  styleUrls: ['./note-modal.component.css']
})
export class NoteModalComponent implements OnInit {

  reminder : number = 0;
  note : Note = {
    id : 0,
    note : "",
    reminder : "",
    reminderDate : "",
    popup : 0
  }
  
  constructor(
    private dialogRef : MatDialogRef<NoteModalComponent>,
    private noteService : NotesService,
    private msgService : MessageService,
    @Inject(MAT_DIALOG_DATA) public data
  ) { 
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    console.log(this.data.id);
    if(this.data.id){
      this.noteService.getNote(this.data.id).subscribe(res => {
        this.note = res.data;
        
      })
    }
  }

  saveNote(){
    let noteData : {id : number, modelId : number, modelName : string, note : string, reminder : string, reminderDate : string, popup : number } = {
      id : this.data.id, modelId : this.data.modelId, modelName : this.data.modelName, note : this.note.note, reminder : this.note.reminder, reminderDate : this.note.reminderDate, popup : this.note.popup
    }
    // console.log(noteData);
    this.noteService.saveNote(noteData).subscribe(res=>{
      if(res.status=='ok'){
        this.msgService.success(res.message);
        this.dialogRef.close(res);
      }else{
        this.msgService.error(res.message);
      }
    })
  }

  setValue(e){
    if(e.checked){
      this.note.popup = 1;
    }else{
      this.note.popup = 0;
    }
  }

  closeModal(){
    this.dialogRef.close(null);
  }


}
